import { FC } from "react";
import { Button } from "@chakra-ui/react";
import { ArrowNarrowLeft } from "~/icons";

interface Props {
  handleClick: () => void;
}

export const BackNavArrowCta: FC<Props> = ({ handleClick }) => {
  return (
    <Button onClick={handleClick} variant="th-button-text">
      <ArrowNarrowLeft />
    </Button>
  );
};
